import { useSelectSlice } from "@common/redux/selectors/useSelectSlice";
import { restaurantsSlice } from "@common/redux/slices/entities.slice";
import { IRestaurant } from "@common/redux/types/places";
import { EntitiesGrid } from "@kursk/components/ui/EntitiesGrid/EntitiesGrid";
import { EntityCard } from "@kursk/components/ui/EntityCard/EntityCard";
import { getCardTypeByIdx } from "@kursk/utils/getCardTypeByIdx";
import { useOrientations } from "@common/hooks/useOrientation";
import { useCallback } from "react";

export function RestaurantsGrid() {
  const { items, total, offset } = useSelectSlice(restaurantsSlice);
  const orientation = useOrientations()
  const getCardType = useCallback((index) => {
    return getCardTypeByIdx(index, orientation)
  }, [orientation])

  return (
    <EntitiesGrid
      <IRestaurant>
      entityType="restaurants"
      items={items}
      total={total}
      offset={offset}
      renderGridCard={(item: IRestaurant, index) => <EntityCard key={item._id}
        type={getCardType(index)}
        entityType="restaurants" entity={item}/>}
    />
  );
}
